import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootSaga from '../sagas/index';
import rootReducer from '../reducers/index';

import middleware, { sagaMiddleware } from './middleware';

const reducer = persistReducer(
  {
    key: 'visit-doctor-dashboard-v22', // key is required
    storage, // storage is now required
    // `info` is persisted via its own nested persistReducer (see reducers/index.js)
    // so the huge `sponsors` array (~68k items) can be excluded. It is blacklisted
    // here so the root doesn't ALSO persist it (with sponsors) — that blew past the
    // ~5MB localStorage quota, and a failed setItem silently drops the WHOLE write
    // (including user.authToken), which is what logged users out on refresh.
    //
    // Only `user` (authToken + doctor identity), `savedPrescription` (per-consult
    // drafts, keyed by consultationId) and `app`'s login flags legitimately need to
    // survive a refresh. Everything below is either re-fetched on load or transient
    // per-session, so it is blacklisted to keep the persisted blob small and to
    // stop stale per-consult data (chat/symptoms/conditions/consults) rehydrating
    // and bleeding across consultations.
    blacklist: [
      'filters',
      'videoSession',
      'info',
      'fwaDigi',
      'consults',
      'chat',
      'symptoms',
      'conditions',
      'videoFeedback',
      'loginError',
      'consultation',
      'lastDigitisation',
      'digitisationPincode',
    ],
  },
  combineReducers({ ...rootReducer })
);

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/* istanbul ignore next */
const configStore = (initialState = {}) => {
  const store = createStore(
    reducer,
    initialState,
    composeEnhancer(applyMiddleware(...middleware))
  );

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      store.replaceReducer(require('../reducers/index').default);
    });
  }

  return {
    persistor: persistStore(store),
    store,
  };
};

const { store, persistor } = configStore();

global.store = store;

export { store, persistor };
